import {Tolgee, DevTools, FormatSimple, BackendFetch} from "@tolgee/react";
import {KEY_LANGUAGE_SESSION_STORAGE} from "../shared/utils/constants";
import {LANGUAGE_CHANGED_EVENT} from "../shared/hooks/useSelectedLanguage";

export const tolgee = Tolgee()
    .use(DevTools())
    .use(FormatSimple())
    .use(BackendFetch({ prefix: "https://cdn.tolg.ee/2fd42a24b086490cb0c700227fcb3d0b" }))
    .init({
        language: sessionStorage.getItem(KEY_LANGUAGE_SESSION_STORAGE) || 'en', // Default language
        fallbackLanguage: 'en', // Fallback language
    });

export const changeLanguage = (language) => {
    sessionStorage.setItem(KEY_LANGUAGE_SESSION_STORAGE, language);
    tolgee.changeLanguage(language)
        .then(() => {
            console.log(`Changed language to: ${language}`);
            window.dispatchEvent(new CustomEvent(LANGUAGE_CHANGED_EVENT, {detail: {language}}));
        })
        .catch((err) => {
            console.error(`Error changing language: ${err}`);
        })
}